import type { MenuProps } from 'antd';
import { IndividualType } from 'store/individuals/individual';
import { SidebarNodeType } from './SidebarNode';
import {
    INVOICES_ACCESS_ROLES,
    JOBS_ACCESS_ROLES,
    MANIFESTS_ACCESS_ROLES,
    TEAMS_ACCESS_ROLES,
} from 'config/roles/roles';

export const defaultMain: SidebarNodeType[] = [
    {
        id: 1,
        parent: 0,
        text: 'Dashboard',
        data: { icon: 'home', url: '/home' },
    },
    {
        id: 2,
        parent: 0,
        text: 'Manifests',
        data: {
            icon: 'shipments',
            url: '/manifests',
            activeOn: /\/manifests.*/,
            forIndividualType: {
                not: false,
                value: MANIFESTS_ACCESS_ROLES.READ,
            },
        },
    },
    {
        id: 3,
        parent: 0,
        text: 'Jobs',
        data: {
            icon: 'jobs',
            url: '/jobs',
            activeOn: /^\/jobs.*/,
            forIndividualType: { not: false, value: JOBS_ACCESS_ROLES.READ },
        },
    },
    {
        id: 4,
        parent: 0,
        text: 'Invoices',
        data: {
            icon: 'invoices',
            url: '/invoices',
            activeOn: /^\/invoices.*/,
            forIndividualType: { not: false, value: INVOICES_ACCESS_ROLES.DASHBOARD },
        },
    },
    // Note: Hiding this part until it is complete
    // {
    //     id: 5,
    //     parent: 0,
    //     text: 'Shipments',
    //     data: {
    //         icon: 'shipments',
    //         url: '/shipments',
    //         activeOn: /\/shipments.*/,
    //         forIndividualType: { not: false, value: SHIPMENTS_ACCESS_ROLES },
    //     },
    // },
    {
        id: 8,
        parent: 7,
        text: 'Irish Customs',
        droppable: true,
        data: { icon: 'irelandFlag' },
    },
    {
        id: 9,
        parent: 7,
        text: 'UK Customs',
        droppable: true,
        data: { icon: 'ukFlag' },
    },
    {
        id: 10,
        parent: 7,
        text: 'EU Customs',
        droppable: true,
        data: { icon: 'euFlag' },
    },
    {
        id: 11,
        parent: 7,
        text: 'Templates',
        data: {
            icon: 'templates',
            url: '/templates',
            forIndividualType: { not: true, value: [IndividualType.DRIVER, IndividualType.HAULIER_ADMIN] },
        },
    },
    {
        id: 12,
        parent: 8,
        text: 'Product Templates',
        data: {
            url: '/customs-declarations/ireland/IMPORT/products/H1',
            activeOn: /\/customs-declarations\/ireland\/.+\/products/,
        },
    },
    {
        id: 13,
        parent: 8,
        text: 'Import (AIS)',
        data: {
            url: '/customs-declarations/ireland/IMPORT',
            activeOn: /\/(customs-declarations|invoice-upload)\/ireland\/IMPORT(?!\/products)/,
            customTrigger: 'ireland/IMPORT',
        },
    },
    {
        id: 14,
        parent: 8,
        text: 'Export (AES)',
        data: {
            url: '/customs-declarations/ireland/EXPORT',
            activeOn: /\/(customs-declarations|invoice-upload)\/ireland\/EXPORT(?!\/products)/,
            customTrigger: 'ireland/EXPORT',
        },
    },
    {
        id: 15,
        parent: 8,
        text: 'Arrival at Exit',
        data: {
            url: '/customs-declarations/ireland/ARRIVAL',
            activeOn: /\/(customs-declarations|invoice-upload)\/ireland\/ARRIVAL(?!\/products)/,
            customTrigger: 'ireland/ARRIVAL',
        },
    },
    {
        id: 17,
        parent: 8,
        text: 'TSD',
        data: {
            url: '/customs-declarations/ireland/TEMPORARY',
            activeOn: /\/(customs-declarations|invoice-upload)\/ireland\/TEMPORARY(?!\/products)/,
            customTrigger: 'ireland/TEMPORARY',
        },
    },
    {
        id: 18,
        parent: 8,
        text: 'PBN',
        data: {
            url: '/customs-declarations/ireland/PBN',
            activeOn: /\/(customs-declarations|invoice-upload)\/ireland\/PBN(?!\/products)/,
            customTrigger: 'ireland/PBN',
        },
    },
    {
        id: 19,
        parent: 8,
        text: 'NCTS',
        data: {
            url: '/customs-declarations/ireland/NCTS',
            activeOn: /\/(customs-declarations|invoice-upload)\/ireland\/NCTS(?!\/products)/,
            customTrigger: 'ireland/NCTS',
        },
    },
    {
        id: 20,
        parent: 8,
        text: 'ETD',
        data: {
            url: '/customs-declarations/ireland/ETD',
            activeOn: /\/(customs-declarations|invoice-upload)\/ireland\/ETD(?!\/products)/,
            customTrigger: 'ireland/ETD',
        },
    },
    {
        id: 21,
        parent: 9,
        text: 'Product Templates',
        data: {
            url: '/customs-declarations/uk/IMPORT/products/H1',
            activeOn: /\/customs-declarations\/uk\/.+\/products/,
        },
    },
    {
        id: 22,
        parent: 9,
        text: 'Import',
        data: {
            url: '/customs-declarations/uk/IMPORT',
            activeOn: /\/(customs-declarations|invoice-upload)\/uk\/IMPORT(?!\/products)/,
            customTrigger: 'uk/IMPORT',
        },
    },
    {
        id: 23,
        parent: 9,
        text: 'Export',
        data: {
            url: '/customs-declarations/uk/EXPORT',
            activeOn: /\/(customs-declarations|invoice-upload)\/uk\/EXPORT(?!\/products)/,
            customTrigger: 'uk/EXPORT',
        },
    },
    {
        id: 24,
        parent: 9,
        text: 'GVMS',
        data: {
            url: '/customs-declarations/uk/GVMS',
            activeOn: /\/(customs-declarations|invoice-upload)\/uk\/GVMS(?!\/products)/,
            customTrigger: 'uk/GVMS',
        },
    },
    {
        id: 25,
        parent: 9,
        text: 'NCTS',
        data: {
            url: '/customs-declarations/uk/NCTS',
            activeOn: /\/(customs-declarations|invoice-upload)\/uk\/NCTS(?!\/products)/,
            customTrigger: 'uk/NCTS',
        },
    },
];

export const declarationsMenu: SidebarNodeType[] = [
    {
        id: 8,
        parent: 1,
        text: 'Irish Customs',
        droppable: true,
        data: { icon: 'irelandFlag' },
    },
    {
        id: 9,
        parent: 1,
        text: 'UK Customs',
        droppable: true,
        data: { icon: 'ukFlag' },
    },
    {
        id: 10,
        parent: 1,
        text: 'EU Customs',
        droppable: true,
        data: { icon: 'euFlag' },
    },
    {
        id: 11,
        parent: 1,
        text: 'Templates',
        data: {
            icon: 'templates',
            url: '/templates',
            forIndividualType: { not: true, value: [IndividualType.DRIVER, IndividualType.HAULIER_ADMIN] },
        },
    },
    {
        id: 12,
        parent: 8,
        text: 'Product Templates',
        data: {
            url: '/customs-declarations/ireland/IMPORT/products/H1',
            activeOn: /\/customs-declarations\/ireland\/.+\/products/,
        },
    },
    {
        id: 13,
        parent: 8,
        text: 'Import (AIS)',
        data: {
            url: '/customs-declarations/ireland/IMPORT',
            activeOn: /\/(customs-declarations|invoice-upload)\/ireland\/IMPORT(?!\/products)/,
            customTrigger: 'ireland/IMPORT',
        },
    },
    {
        id: 14,
        parent: 8,
        text: 'Export (AES)',
        data: {
            url: '/customs-declarations/ireland/EXPORT',
            activeOn: /\/(customs-declarations|invoice-upload)\/ireland\/EXPORT(?!\/products)/,
            customTrigger: 'ireland/EXPORT',
        },
    },
    {
        id: 15,
        parent: 8,
        text: 'Arrival at Exit',
        data: {
            url: '/customs-declarations/ireland/ARRIVAL',
            activeOn: /\/(customs-declarations|invoice-upload)\/ireland\/ARRIVAL(?!\/products)/,
            customTrigger: 'ireland/ARRIVAL',
        },
    },
    {
        id: 17,
        parent: 8,
        text: 'TSD',
        data: {
            url: '/customs-declarations/ireland/TEMPORARY',
            activeOn: /\/(customs-declarations|invoice-upload)\/ireland\/TEMPORARY(?!\/products)/,
            customTrigger: 'ireland/TEMPORARY',
        },
    },
    {
        id: 18,
        parent: 8,
        text: 'PBN',
        data: {
            url: '/customs-declarations/ireland/PBN',
            activeOn: /\/(customs-declarations|invoice-upload)\/ireland\/PBN(?!\/products)/,
            customTrigger: 'ireland/PBN',
        },
    },
    {
        id: 19,
        parent: 8,
        text: 'NCTS',
        data: {
            url: '/customs-declarations/ireland/NCTS',
            activeOn: /\/(customs-declarations|invoice-upload)\/ireland\/NCTS(?!\/products)/,
            customTrigger: 'ireland/NCTS',
        },
    },
    {
        id: 20,
        parent: 8,
        text: 'ETD',
        data: {
            url: '/customs-declarations/ireland/ETD',
            activeOn: /\/(customs-declarations|invoice-upload)\/ireland\/ETD(?!\/products)/,
            customTrigger: 'ireland/ETD',
        },
    },
    {
        id: 21,
        parent: 9,
        text: 'Product Templates',
        data: {
            url: '/customs-declarations/uk/IMPORT/products/H1',
            activeOn: /\/customs-declarations\/uk\/.+\/products/,
        },
    },
    {
        id: 22,
        parent: 9,
        text: 'Import',
        data: {
            url: '/customs-declarations/uk/IMPORT',
            activeOn: /\/(customs-declarations|invoice-upload)\/uk\/IMPORT(?!\/products)/,
            customTrigger: 'uk/IMPORT',
        },
    },
    {
        id: 23,
        parent: 9,
        text: 'Export',
        data: {
            url: '/customs-declarations/uk/EXPORT',
            activeOn: /\/(customs-declarations|invoice-upload)\/uk\/EXPORT(?!\/products)/,
            customTrigger: 'uk/EXPORT',
        },
    },
    {
        id: 24,
        parent: 9,
        text: 'GVMS',
        data: {
            url: '/customs-declarations/uk/GVMS',
            activeOn: /\/(customs-declarations|invoice-upload)\/uk\/GVMS(?!\/products)/,
            customTrigger: 'uk/GVMS',
        },
    },
    {
        id: 25,
        parent: 9,
        text: 'NCTS',
        data: {
            url: '/customs-declarations/uk/NCTS',
            activeOn: /\/(customs-declarations|invoice-upload)\/uk\/NCTS(?!\/products)/,
            customTrigger: 'uk/NCTS',
        },
    },
    {
        id: 26,
        parent: 10,
        text: 'ENS (ICS2)',
        data: {
            url: '/customs-declarations/eu/ENS',
            activeOn: /\/(customs-declarations|invoice-upload)\/eu\/ENS(?!\/products)/,
            customTrigger: 'en/ENS',
        },
    },

    {
        id: 27,
        parent: 10,
        text: 'Arrival Notification (ICS2)',
        data: {
            url: '/customs-declarations/eu/ARRIVAL_NOTIFICATION_ICS2',
            activeOn: /\/(customs-declarations|invoice-upload)\/eu\/ARRIVAL_NOTIFICATION_ICS2/,
            customTrigger: 'eu/ARRIVAL_NOTIFICATION_ICS2',
        },
    },
];

export const operationsMenu: SidebarNodeType[] = [
    {
        id: 2,
        parent: 2,
        text: 'Parties',
        data: { icon: 'customers', url: '/customers', activeOn: /^\/customers$/ },
    },
    {
        id: 3,
        parent: 2,
        text: 'Teams',
        data: {
            icon: 'teams',
            url: '/teams',
            activeOn: /\/teams/,
            forIndividualType: {
                not: false,
                value: TEAMS_ACCESS_ROLES,
            },
        },
    },
    {
        id: 6,
        parent: 2,
        text: 'Commodity Conditions',
        data: {
            icon: 'table',
            url: '/commodity-conditions-center',
            activeOn: /\/commodity-conditions-center/,
        },
    },
    {
        id: 4,
        parent: 2,
        text: 'Settings',
        data: {
            icon: 'settings',
            url: '/settings/personal-information',
            activeOn: /\/settings/,
        },
    },
];

export const items: MenuProps['items'] = [
    {
        key: 1,
        label: 'Ireland',
        type: 'group',
        children: [
            {
                key: 13,
                label: 'Import (AIS)',
                data: {
                    url: '/customs-declarations/ireland/IMPORT',
                    activeOn: /\/(customs-declarations|invoice-upload)\/ireland\/IMPORT(?!\/products)/,
                    customTrigger: 'ireland/IMPORT',
                },
            },
            {
                key: 14,
                label: 'Export (AES)',
                data: {
                    url: '/customs-declarations/ireland/EXPORT',
                    activeOn: /\/(customs-declarations|invoice-upload)\/ireland\/EXPORT(?!\/products)/,
                    customTrigger: 'ireland/EXPORT',
                },
            },
            {
                key: 15,
                label: 'Arrival at Exit',
                data: {
                    url: '/customs-declarations/ireland/ARRIVAL',
                    activeOn: /\/(customs-declarations|invoice-upload)\/ireland\/ARRIVAL(?!\/products)/,
                    customTrigger: 'ireland/ARRIVAL',
                },
            },
            {
                key: 17,
                label: 'TSD',
                data: {
                    url: '/customs-declarations/ireland/TEMPORARY',
                    activeOn: /\/(customs-declarations|invoice-upload)\/ireland\/TEMPORARY(?!\/products)/,
                    customTrigger: 'ireland/TEMPORARY',
                },
            },
            {
                key: 18,
                label: 'PBN',
                data: {
                    url: '/customs-declarations/ireland/PBN',
                    activeOn: /\/(customs-declarations|invoice-upload)\/ireland\/PBN(?!\/products)/,
                    customTrigger: 'ireland/PBN',
                },
            },
            {
                key: 19,
                label: 'NCTS',
                data: {
                    url: '/customs-declarations/ireland/NCTS',
                    activeOn: /\/(customs-declarations|invoice-upload)\/ireland\/NCTS(?!\/products)/,
                    customTrigger: 'ireland/NCTS',
                },
            },
            {
                key: 20,
                label: 'ETD',
                data: {
                    url: '/customs-declarations/ireland/ETD',
                    activeOn: /\/(customs-declarations|invoice-upload)\/ireland\/ETD(?!\/products)/,
                    customTrigger: 'ireland/ETD',
                },
            },
        ] as any,
    },
    {
        key: 21,
        label: 'UK',
        type: 'group',
        children: [
            {
                key: 22,
                label: 'Import',
                data: {
                    url: '/customs-declarations/uk/IMPORT',
                    activeOn: /\/(customs-declarations|invoice-upload)\/uk\/IMPORT(?!\/products)/,
                    customTrigger: 'uk/IMPORT',
                },
            },
            {
                key: 23,
                label: 'Export',
                data: {
                    url: '/customs-declarations/uk/EXPORT',
                    activeOn: /\/(customs-declarations|invoice-upload)\/uk\/EXPORT(?!\/products)/,
                    customTrigger: 'uk/EXPORT',
                },
            },
            {
                key: 24,
                label: 'GVMS',
                data: {
                    url: '/customs-declarations/uk/GVMS',
                    activeOn: /\/(customs-declarations|invoice-upload)\/uk\/GVMS(?!\/products)/,
                    customTrigger: 'uk/GVMS',
                },
            },
            {
                key: 25,
                label: 'NCTS',
                data: {
                    url: '/customs-declarations/uk/NCTS',
                    activeOn: /\/(customs-declarations|invoice-upload)\/uk\/NCTS(?!\/products)/,
                    customTrigger: 'uk/NCTS',
                },
            },
        ] as any,
    },
];
